<template>
    <div>
        <div class="outer_label">
            <!-- <img class="inner_label login_logo" src="../../assets/logo.png"> -->
        </div>
        <div class="login_form">
            <a-input :placeholder="$t('dj-用户名')" v-model="userName" />
            <a-input-password :placeholder="$t('dj-密码')" v-model="password" />
            <a-button
                class="login_btn"
                value="large"
                @click.native="login"
                type="primary"
                round
                :loading="isBtnLoading"
            >{{ $t("dj-登录") }}</a-button
            >
        </div>
    </div>
</template>


<script>
import { JSEncrypt } from 'jsencrypt';
import * as crypto from 'crypto-js';
import api from '@/api';
import i18n from '@/assets/i18n/translate-message';

export default {
    data() {
        return {
            userName: '',
            password: '',
            isBtnLoading: false,
        };
    },
    created() {
    },
    computed: {},
    methods: {
        clearStorage() {
            localStorage.removeItem('userName');
            localStorage.removeItem('language');
            localStorage.removeItem('token');
            this.$store.commit('auth/CLEAR_USER_STATE');
        },
        async login() {
            if (!this.userName) {
                this.$message.error(i18n.t('dj-请输入用户名'));
                return;
            }
            if (!this.password) {
                this.$message.error(i18n.t('dj-请输入密码'));
                return;
            }
            this.clearStorage();

            const param = { userId: this.userName, password: this.password };
            const body = await this.getLoginApiBody(param);
            const res = await api.authLogin(body);

            if (res.status === 200 && res.data) {
                const authData = res.data;
                i18n.locale = authData?.acceptLanguage ?? 'zh_CN';
                localStorage.setItem('language', authData?.acceptLanguage ?? 'zh_CN');
                this.$i18n.locale = authData?.acceptLanguage ?? 'zh_CN';
                localStorage.setItem('userName', authData.userName);
                localStorage.setItem('token', authData.token);
                this.$store.commit('auth/SET_ROUTER_KEY', authData.tenantId)
                this.$store.commit('auth/SET_AUTH_INFO', authData);
                this.$router.push('domains/athena');
                const resTenantList = await api.getTenantList();
                if (resTenantList.status === 200 && resTenantList.data) {
                    this.$store.commit('auth/SET_TENANT_LIST', resTenantList.data ?? []);
                } else {
                    this.$message.error(i18n.t('dj-获取租户列表失败'));
                    return;
                }
            } else {
                this.$message.error(i18n.t('dj-登录失败，请重试'));
                return;
            }
        },
        async getLoginApiBody(userConfig) {
            const resUserSalt = (await api.getUserSaltHttp(this.userName)).data;

            // publish key 加密
            const resPublishKey = (await api.getIdentityPublickey()).data;

            const crypt = new JSEncrypt({ default_key_size: 1024 });
            let rsaPublicKey = crypt.getPublicKey();
            rsaPublicKey = rsaPublicKey.replace('-----BEGIN PUBLIC KEY-----\n', '');
            rsaPublicKey = rsaPublicKey.replace('\n-----END PUBLIC KEY-----', '');
            const cryptSrv = new JSEncrypt({ default_key_size: 2048 });

            const publicKeyStr = resPublishKey.publicKey;
            cryptSrv.setPublicKey(publicKeyStr);

            // aeskey加密

            const clientEncryptPublicKey = cryptSrv.encrypt(rsaPublicKey);
            const resAes = await this.getAESTrans(crypt, clientEncryptPublicKey);
            const key = crypto.enc.Utf8.parse(resAes.aeskey);
            const iv = crypto.enc.Utf8.parse('ghUb#er57HBh(u%g');
            const passwordHash = crypto.AES.encrypt(userConfig.password, key, {
                iv,
                mode: crypto.mode.CBC,
                padding: crypto.pad.Pkcs7,
            }).toString();

            // 返回处理
            const body = {
                // tenantId: 'default',
                userId: userConfig.userId,
                name: userConfig.userId,
                identityType: 'query',
            };

            Object.assign(body, {
                passwordHash,
                clientEncryptPublicKey: resAes.clientEncryptPublicKey,
            });

            // 如果有服務雲帳號特有的salt則需加傳 passwordHash1
            if (resUserSalt.salt) {
                Object.assign(body, {
                    passwordHash1: crypto
                        .MD5(userConfig.password + resUserSalt.salt)
                        .toString(),
                });
            }

            return body;
        },
        async getAESTrans(crypt, clientEncryptPublicKey) {
            const resAesKey = (await api.getIdentityAeskey(clientEncryptPublicKey)).data;
            const aesKey = crypt.decrypt(resAesKey.encryptAesKey);
            const resAes = {
                aeskey: aesKey,
                clientEncryptPublicKey,
            };
            return resAes;
        },

    },

};
</script>
<style lang='less'>
.login_form {
  padding-top: 10%;
  padding-left: 40%;
  padding-right: 40%;
  display: flex;
  flex-direction: column;
  input {
    margin: 10px 0;
    height: 40px;
  }
  button {
    margin-top: 20px;
    margin-left: auto;
    height: 40px;
    padding: 0 20px;
  }
}
.login_logo {
  height: 100%;
}
</style>
